import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { orgTranslationRef } from '@backstage/plugin-org/alpha';

export const orgTranslations = createTranslationResource({
  ref: orgTranslationRef,
  translations: {
    'pt-BR': () => import('./pt-BR'),
  },
});
